import React from "react";
import { Box, Divider } from "@mui/material";
import InnerFrame from "../shared/InnerFrame";
import SkillRow from "./SkillRow";

export default function SkillCard({
  parentSkill,
  childSkills,
  onParentLevelChange,
  onChildLevelChange,
  isDesktop,
}) {
  if (!parentSkill) return null;

  const normalizedChildSkills = Array.isArray(childSkills) ? childSkills : [];

  return (
    <InnerFrame
      sx={{
        p: isDesktop ? 5 : 2.5,
        width: "100%",
        maxWidth: "900px",
        mx: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: isDesktop ? 3 : 0,
        }}
      >
        <SkillRow
          displayName={parentSkill.displayName}
          experienceLabel={parentSkill.experienceLabel}
          levelValue={parentSkill.levelValue}
          onChangeLevel={onParentLevelChange}
          isDesktop={isDesktop}
        />

        {normalizedChildSkills.length > 0 && <Divider sx={{ my: 1 }} />}

        {normalizedChildSkills.map((childSkill) => (
          <Box
            key={childSkill.recordId}
            sx={{
              pl: isDesktop ? 0 : 3,
              pt: isDesktop ? 0 : 2.5,
            }}
          >
            <SkillRow
              displayName={childSkill.displayName}
              experienceLabel={childSkill.experienceLabel}
              levelValue={childSkill.levelValue}
              isChild
              isDesktop={isDesktop}
              onChangeLevel={(value) =>
                onChildLevelChange(childSkill.recordId, value)
              }
            />
          </Box>
        ))}
      </Box>
    </InnerFrame>
  );
}
